module.exports = __webpack_public_path__ + "img/MFF.e89a9c1b.jpg";